module.exports = __webpack_public_path__ + "arrow@2x.6a40e6b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/template/OnBoardingNatural/images/arrow@2x.png
// module id = 6bID
// module chunks = 0